import {LanguageType} from '../language/type';

export const LOCATION_TYPE = (TEXTE: LanguageType) => [
	{value: 'lease', render: TEXTE.global.lease},
	{value: 'purchase', render: TEXTE.global.purchase}
];

export const STATE = (TEXTE: LanguageType) => [
	{value: 'new', render: TEXTE.global.new},
	{value: 'refurbished', render: TEXTE.global.refurbished}
];

export const DEVICE_TYPE = (TEXTE: LanguageType) => [
	{value: 'computer', render: TEXTE.global.computer},
	{value: 'phone', render: TEXTE.global.phone},
	{value: 'tablet', render: TEXTE.global.tablet},
	{value: 'hub', render: TEXTE.global.hub},
	{value: 'headphones', render: TEXTE.global.headphones},
	{value: 'mouse', render: TEXTE.global.mouse},
	{value: 'keyboard', render: TEXTE.global.keyboard},
	{value: 'speaker', render: TEXTE.global.speaker},
	{value: 'screen', render: TEXTE.global.screen},
	{value: 'sim', render: TEXTE.global.sim},
	{value: 'other', render: TEXTE.global.other}
];
